/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import { breakpoints, GridContainer, GridItem } from "./Grid.Style"

const gridColumns = {
    1: 'repeat(1, 1fr)',
    2: 'repeat(2, 1fr)',
    3: 'repeat(3, 1fr)',
    4: 'repeat(4, 1fr)',
    6: 'repeat(6, 1fr)',
    8: 'repeat(8, 1fr)',
    12: 'repeat(12, 1fr)',
};

const Grid = ({
    container,
    span,
    xxs,
    xs,
    sm,
    md,
    lg,
    xl,
    spacingColumn,
    spacingRow,
    children,
    as: Component = 'div',
}) => {
    if (container) {
        const responsiveStyles = Object.keys(breakpoints).reduce((styles, breakpoint) => {
            if (span) {
                styles[`@media ${breakpoints[breakpoint]}`] = {
                    gridTemplateColumns: gridColumns[span],
                };
            }
            return styles;
        }, {});

        return (
            <GridContainer as={Component} spacingRow={spacingRow} spacingColumn={spacingColumn} responsiveStyles={responsiveStyles}>
                {React.Children.map(children, child => {
                    if (React.isValidElement(child) && child.props.span) {
                        return React.cloneElement(child, {
                            span: child.props.span,
                        });
                    }
                    return child;
                })}
            </GridContainer>
        );
    }

    return (
        <GridItem
            as={Component}
            span={span}
            xxs={xxs}
            xs={xs}
            sm={sm}
            md={md}
            lg={lg}
            xl={xl}
        >
            {children}
        </GridItem>
    );
};

Grid.propTypes = {
    container: PropTypes.bool,
    span: PropTypes.number,
    xxs: PropTypes.number,
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number,
    spacingColumn: PropTypes.number,
    spacingRow: PropTypes.number,
    children: PropTypes.node,
    as: PropTypes.elementType,
};

Grid.defaultProps = {
    container: false,
    span: 12,
    xxs: null,
    xs: null,
    sm: null,
    md: null,
    lg: null,
    xl: null,
    spacingColumn: 0,
    spacingRow: 0,
    children: null,
    as: 'div',
};

export default Grid;
